/* eslint 'array-callback-return': 'off', eqeqeq: 'off'  */
import React, { Component } from 'react';
import { Row, Col, Button, FormGroup,Table, Modal } from 'reactstrap';
import '../../../../../../Assets/EnsembleStyles/EnsCreateTenant.css';
import {FaQuestionCircle} from 'react-icons/fa';
import { Redirect } from 'react-router-dom';
import { SaveZonesDetailsforclient } from '../../../../../../action/manageTenantAction';
import { GetZonesList } from '../../../../../../action/ZonesAction';
import classnames from 'classnames';
import { connect } from 'react-redux';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { getAllResources } from '../../../../../../action/cultureAction';


class CreateTenant_Zones extends Component {
    componentWillMount(){
        this.props.GetZonesList();
    }
    componentDidMount(){
        if(this.props.getLabels["ManageTenants.Create.Text"] === undefined){
            this.props.getAllResources();
        }
        if(this.props.ClientSideZonesState != undefined && this.props.ClientSideZonesState != null){
            this.setState({
                SelectedZones: this.props.ClientSideZonesState
            });
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            routeModules: { },
            redirect:  false,
            redirectBack: false,
            SelectedZones: [],
            modal: false,
            IsModalClose: false
        }
        this.goNext = this.goNext.bind(this);
        this.toggle = this.toggle.bind(this);
        this.RemoveZones = this.RemoveZones.bind(this);
        this.SaveSelectedZones = this.SaveSelectedZones.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    goBack (){
        this.setState({redirectBack: true});
    }

    SaveSelectedZones(Rows){
        this.setState({IsModalClose: false});
        var lstZones = this.state.SelectedZones;
        let IsAnyZoneSelected = false;
        for(let i=0; i < Rows.length; i++){
            if(Rows[i] != undefined){
            var id = Rows[i].props.children[0].props.children.ref;
            if(this.refs[id].checked){
                let ZoneId = this.refs[id].value;
                let ZoneName = Rows[i].props.children[1].props.children;
                let Building = Rows[i].props.children[2].props.children;
                let Members =  Rows[i].props.children[3].props.children;
                let MembersObj = [];
                if (this.props.getResponse != undefined && this.props.getResponse.ZonesList !== undefined && this.props.getResponse.ZonesList.length) {
                    var lData = this.props.getResponse.ZonesList.filter(x => x.zoneId.toString() === ZoneId.toString());
                    MembersObj = (lData[0] !== undefined && lData[0] !== null) ? lData[0].members : []; 
                }
                lstZones.push({zoneId:ZoneId,zoneName:ZoneName,buildingName:Building,members:Members, memberDetails:MembersObj})
                IsAnyZoneSelected = true;
            }
            }
        }
        if(!IsAnyZoneSelected){
            this.setState({IsModalClose: true});
        }else{
            this.setState({
                SelectedZones: lstZones,
                modal: !this.state.modal
            });
        }
    }

    RemoveZones(Rows){
        this.setState({IsModalClose: false});
        var lstZones = [];
        let IsAnyZoneSelected = false;
        for(let i=0; i < Rows.length; i++){
            if(Rows[i] != undefined){
            var id = Rows[i].props.children[0].props.children.ref;
            if(!this.refs[id].checked){
                let ZoneId = this.refs[id].value;
                let ZoneName = Rows[i].props.children[1].props.children;
                let Building = Rows[i].props.children[2].props.children;
                let Members =  (new Array(Rows[i].props.children[3].props.children)).join(',');
                let MembersObj = [];
                if (this.props.getResponse != undefined && this.props.getResponse.ZonesList !== undefined && this.props.getResponse.ZonesList.length) {
                    var lData = this.props.getResponse.ZonesList.filter(x => x.zoneId.toString() === ZoneId.toString());
                    MembersObj = (lData[0] !== undefined && lData[0] !== null) ? lData[0].members : []; 
                }
                lstZones.push({zoneId:ZoneId,zoneName:ZoneName,buildingName:Building,members:Members,zonRate:0,memberDetails:MembersObj})
                
            }else{
                IsAnyZoneSelected = true;
            }
            }
        }
        this.setState({
            SelectedZones: lstZones
        });
        if(!IsAnyZoneSelected)
            this.setState({IsModalClose: true});
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }
   
    goNext (e) {
        this.setState({redirect: true});
        this.props.SaveZonesDetailsforclient(this.state.SelectedZones);
    }
    render(getResponse, ClientSideZonesState,getLabels) {
        let label = this.props.getLabels;
        if(this.state.redirect){
            return <Redirect to={"/managetenant/TenantAfterHours"} />
        }
        if(this.state.redirectBack){
            return <Redirect to={"/managetenant/CreateTenant"} />
        }
        if(this.state.IsModalClose){
            var errormsg = <p  className="error_msg">
            <img src={ErrorGif} alt="Trane Logo" /> 
             {label['CheckEmptyZones.Text'] !== undefined ? label['CheckEmptyZones.Text'] : "Error: Select one or more Zone to perform this action."}
            </p> 
        }
        let Available_Zones, modal_form_1, ZonesList,Available_List;
        if (this.props.getResponse != undefined) {
            if (this.props.getResponse.ZonesList.length) { 

                if(this.state.SelectedZones.length == 0){
                Available_Zones = this.props.getResponse.ZonesList.map(el => (
                            <tr>
                                <td><input type="checkbox" ref={'ref_' + el.zoneId} value={el.zoneId} className="AvailZones_child_Check_box" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("AvailZones_child_Check_box","AvailZones_header_Check_box"); }} /></td>
                                <td>{el.zoneName}</td>
                                <td>{el.buildingName}</td>
                                <td>{ el.members.map(xl =>(xl.objectName)).join(", ")}</td>
                            </tr>
                ));
                }else{

                    Available_List = this.props.getResponse.ZonesList.filter((obj) => {
                        let HasId = false;
                        for (let i = 0, length = this.state.SelectedZones.length; i < length; i++) {
                            if (obj.zoneId === parseInt(this.state.SelectedZones[i].zoneId)) HasId = true;
                        }
                        if(!HasId) return true;
                    })
                    
                    Available_Zones = Available_List.map(el => (
                         <tr>
                            <td><input type="checkbox" ref={'ref_' + el.zoneId} value={el.zoneId} className="AvailZones_child_Check_box" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("AvailZones_child_Check_box","AvailZones_header_Check_box"); }} /></td>
                            <td>{el.zoneName}</td>
                            <td>{el.buildingName}</td>
                            <td>{ el.members.map(xl =>(xl.objectName)).join(", ")}</td>
                        </tr>
                        
                    ));
                    if(Available_Zones.length == 0){
                        Available_Zones =<tr>
                            <td colSpan="4">{label['NoRecords.Text']}</td>
                            </tr>
                    }
                }
            }
            else{
                    Available_Zones = 
                            <tr>
                            <td colSpan="4">{label['NoRecords.Text']}</td>
                            </tr>
            }
        }else{
            Available_Zones =  <p>{label['LoadingData.Text']}</p>
        }
        //Selected Zones Grid
        if(this.state.SelectedZones != null && this.state.SelectedZones.length > 0){
        ZonesList = this.state.SelectedZones.map(el => (
            <tr>
                <td><input type="checkbox" ref={'ref1_' + el.zoneId} value={el.zoneId} className="SelectedZones_Child_Check_box" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("SelectedZones_Child_Check_box","SelectedZones_header_Check_box"); }}/></td>
                <td>{el.zoneName}</td>
                <td>{el.buildingName}</td>
                <td>{ el.members}</td>
            </tr>
        ));
        }else{
            ZonesList =
                        <tr>
                          <td colSpan="4">{label['NoRecords.Text']}</td>
                        </tr>
        }
        modal_form_1 =  <div className="table_container">
                        {errormsg}
                        <legend className="form_sub_title">{label['TenantZones.AddExistingZone.Text'] !== undefined ? label['TenantZones.AddExistingZone.Text'] : "Add Zone"} </legend>
                        <div style={{ width: '100%', overflowY: 'auto', maxHeight: '280px' }}>
                        <Table striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th width="5px;"><input type="checkbox" className="AvailZones_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("AvailZones_child_Check_box","AvailZones_header_Check_box"); }} /></th>
                                <th width="30%">{label['DefaultTemplate.Zone.Text']}</th>
                                <th width="25%">{label['SubGroups.Columns.SiteName.Text']}</th>
                                <th width="40%">{label['SubGroups.Columns.Members.Text'] !== undefined ? label['SubGroups.Columns.Members.Text'] : "Members"}</th>                                
                            </tr>
                            {Available_Zones}
                        </tbody>
                        </Table>
                        </div>
                        <FormGroup row className="btns_group">
                            <Col sm={{ size: 10 }}>
                                <Button className="btn-gray btn-md" id="createtenant_zone_cancel" onClick={this.toggle}> {label['TemperatureAdjustment.Cancel.Text'] !== undefined ? label['TemperatureAdjustment.Cancel.Text'] : "Cancel"}  </Button>
                                <Button className="btn-success btn-md" id="createtenant_zone_apply" onClick={() => { this.SaveSelectedZones(Available_Zones);} } >{label['ManageHolidays.Apply.Text'] !== undefined ? label['ManageHolidays.Apply.Text'] : "Apply"}</Button>
                            </Col>
                        </FormGroup>
                        </div>                        

        return (
            <div className="EnsembleCreateTenant">
                 <Row>
                 <Col sm={{size: 1, offset: 11 }} className="text-right" >
                    <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon" />
                 </Col>
                 </Row>
                 {errormsg}
                 <h4 className="form_title">{label['TenantZones.HeaderText.Text']}</h4>
                 <div className="Customised_form_div">
                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button className="btn-black btn-md" id="reatetenant_removezone" onClick={() => { this.RemoveZones(ZonesList);} } > {label['TenantZones.Remove.Text'] !== undefined ? label['TenantZones.Remove.Text'] : "Remove"}  </Button>
                            <Button className="btn-black btn-md" id="createtenant_addzone" onClick={this.toggle}> {label['TenantZones.AddExistingZone.Text'] !== undefined ? label['TenantZones.AddExistingZone.Text'] : "Add Zone"}</Button>
                        </Col>
                    </FormGroup>
                
                    <div className="table_container" style={{paddingRight:'15px'}}>
                    <Table striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th width="5%"><input type="checkbox" className="SelectedZones_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("SelectedZones_Child_Check_box","SelectedZones_header_Check_box"); }} /></th>
                                <th width="30%">{label['TenantZones.Zone.Text'] !== undefined ? label['TenantZones.Zone.Text'] : "Zone"}</th>
                                <th width="25%">{label['TenantZones.Building.Text'] !== undefined ? label['TenantZones.Building.Text']  :"Building"}</th>
                                <th width="40%">{label['TenantZones.Members.Text'] !== undefined ? label['TenantZones.Members.Text'] : "Members"}</th>                                
                            </tr>
                            {ZonesList}
                        </tbody>
                    </Table>
                    </div>

                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                            <Button className="btn-gray btn-md" id="createtenant_zone_back" onClick={this.goBack} > {label['Wizards.BackButton.Text']}</Button>
                            <Button className="btn-success btn-md" id="createtenant_zone_next" onClick={this.goNext}>{label['Wizards.NextButton.Text']} </Button>
                        </Col>
                    </FormGroup>
                </div> 
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    {modal_form_1}
                </Modal>   
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getResponse: state.zonesRootReducer,
        ClientSideZonesState: state.manageTenant.ClientSideZonesData,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetZonesList: () => dispatch(GetZonesList()),
        SaveZonesDetailsforclient: (data) => dispatch(SaveZonesDetailsforclient(data)),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateTenant_Zones);